define('models/country_distributor',['require','backbone','models/country','models/city','models/phone_number','models/cd_manager','models/state'],function(require){

    var Backbone = require('backbone');

    var CountryModel = require('models/country');
    var CityModel = require('models/city');
    var PhoneNumberModel = require('models/phone_number');
    var CDManagerModel = require('models/cd_manager');
    var StateModel = require('models/state');

    return Backbone.Model.extend({
        url : function() {
            // set the endpoint for restful api for articles
            return this.id ? ( App.Config.apiBase + 'country-distributors/' + this.id + '/' ) :
                ( App.Config.apiBase + 'country-distributors/' );
        },

        defaults: function () {
            return {
                id: null,
                company_name: '',
                phone_number: new PhoneNumberModel().attributes,
                phone_country: null,
                phone_value: '',
                foundation_year: 0,
                country: null,
                city_name: '',
                district: '',
                address: '',
                website: '',
                tax_office: '',
                tax_number: '',
                re_branding_brand: '',
                group: null,
                service_languages: [],
                service_types: [],
                website_listing: true,
                status: 2,
                super_reseller_object : {},
                manager_object: new CDManagerModel().attributes,
                city_object: new CityModel().attributes,
                country_object: new CountryModel().attributes,
                wallet: { currency: null, balance: 0 },
                state: null,
                state_object: new StateModel().attributes
            };
        }
    });
});
